import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ServicesList: React.FC = () => {
  const navigate = useNavigate();
  const [activeService, setActiveService] = useState(0);

  const services = [
    {
      id: 'genomics',
      icon: 'ri-dna-line',
      title: '基因组学分析',
      subtitle: 'Genomics Analysis',
      description: '提供全基因组测序（WGS）和外显子测序（WES）的专业分析服务，涵盖从数据质控到功能注释的完整流程，为精准医学和遗传学研究提供可靠的数据支撑。',
      image: 'https://readdy.ai/api/search-image?query=DNA%20double%20helix%20structure%20with%20genomic%20sequencing%20data%20visualization%2C%20colorful%20genetic%20code%20patterns%2C%20modern%20molecular%20biology%20illustration%20with%20clean%20scientific%20background&width=600&height=400&seq=genomics&orientation=landscape',
      features: [
        '数据质控与序列比对',
        '单核苷酸变异（SNV）与插缺失（Indel）检测',
        '拷贝数变异（CNV）与结构变异（SV）分析',
        '突变注释与驱动基因筛选',
        'GISTIC拷贝数驱动分析',
        'HLA分型与新抗原预测',
        'TCR/BCR组装分析',
        '突变指纹识别'
      ]
    },
    {
      id: 'transcriptomics',
      icon: 'ri-bar-chart-line',
      title: '转录组学分析',
      subtitle: 'Transcriptomics Analysis',
      description: '涵盖Bulk RNA-seq、单细胞RNA-seq和空间转录组的全方位分析服务，从基础的差异表达分析到高级的细胞通信和拟时分析，助力转录调控机制研究。',
      image: 'https://readdy.ai/api/search-image?query=RNA%20sequencing%20data%20visualization%20with%20gene%20expression%20heatmaps%2C%20colorful%20bar%20charts%20showing%20differential%20gene%20expression%2C%20modern%20bioinformatics%20analysis%20interface%20with%20clean%20scientific%20background&width=600&height=400&seq=transcriptomics&orientation=landscape',
      features: [
        'Bulk RNA-seq差异表达与功能富集分析',
        '单细胞RNA-seq降维聚类与细胞注释',
        '拟时分析与发育轨迹重构',
        '细胞通信与转录因子活性推断',
        '空间转录组空间聚类与差异基因识别',
        '高分辨率空间转录组细胞亚群识别',
        '共表达网络与调控模块分析',
        '表观调控与转录调控整合分析'
      ]
    },
    {
      id: 'epigenomics',
      icon: 'ri-fingerprint-line',
      title: '表观组学分析',
      subtitle: 'Epigenomics Analysis',
      description: '专业的ATAC-seq和scATAC-seq分析服务，深入解析染色质可及性和表观遗传调控机制，为基因调控网络研究提供重要的表观遗传学证据。',
      image: 'https://readdy.ai/api/search-image?query=Chromatin%20accessibility%20analysis%20with%20ATAC-seq%20peaks%20visualization%2C%20epigenetic%20modifications%20patterns%2C%20transcription%20factor%20binding%20sites%2C%20modern%20epigenomics%20research%20with%20clean%20scientific%20background&width=600&height=400&seq=epigenomics&orientation=landscape',
      features: [
        'ATAC-seq Peak calling与差异可及性分析',
        'scATAC-seq细胞过滤与Peak矩阵构建',
        'Motif富集与转录因子结合位点预测',
        '增强子活性分析与调控元件识别',
        '差异可及性区域（DAR）分析',
        '共可及性网络构建',
        '转录因子活性推断',
        '表观遗传调控网络分析'
      ]
    },
    {
      id: 'proteomics',
      icon: 'ri-microscope-line',
      title: '蛋白质组学分析',
      subtitle: 'Proteomics Analysis',
      description: '提供蛋白质组、CyTOF和代谢组的专业质谱数据分析服务，从蛋白质鉴定定量到代谢通路分析，全面解析分子表型与功能。',
      image: 'https://readdy.ai/api/search-image?query=Protein%20structure%20visualization%20with%203D%20molecular%20models%2C%20mass%20spectrometry%20data%20analysis%2C%20protein%20interaction%20networks%2C%20modern%20proteomics%20research%20laboratory%20with%20clean%20scientific%20background&width=600&height=400&seq=proteomics&orientation=landscape',
      features: [
        '蛋白质组谱图比对与蛋白鉴定',
        '蛋白质定量与差异表达分析',
        'CyTOF细胞亚群识别与注释',
        '蛋白质相互作用网络构建',
        '翻译后修饰（PTM）分析',
        '蛋白质功能富集与通路分析',
        '生物标志物筛选与验证',
        '蛋白质结构功能预测'
      ]
    },
    {
      id: 'metabolomics',
      icon: 'ri-flask-line',
      title: '代谢组学分析',
      subtitle: 'Metabolomics Analysis',
      description: '专业的代谢组和空间代谢组分析服务，从代谢物鉴定定量到代谢通路分析，深入解析代谢网络调控机制和生物标志物发现。',
      image: 'https://readdy.ai/api/search-image?query=Metabolomics%20analysis%20with%20colorful%20chemical%20structure%20diagrams%2C%20metabolic%20pathway%20networks%2C%20mass%20spectrometry%20peaks%2C%20modern%20biochemistry%20laboratory%20with%20clean%20scientific%20background&width=600&height=400&seq=metabolomics&orientation=landscape',
      features: [
        '代谢组峰提取与代谢物定量',
        '差异代谢物筛选与功能富集',
        '代谢通路分析与网络构建',
        '空间代谢组离子峰识别与去噪',
        '代谢物空间分布图构建',
        '主成分分析与偏最小二乘判别分析',
        '代谢物相关网络分析',
        '生物标志物发现与验证'
      ]
    },
    {
      id: 'microbiome',
      icon: 'ri-bug-line',
      title: '微生物组学分析',
      subtitle: 'Front. Immunol Analysis',
      description: '专业的微生物组扩增子测序分析服务，从物种注释到群落结构分析，全面解析微生物群落组成、多样性和功能特征。',
      image: 'https://readdy.ai/api/search-image?query=Front. Immunol%20diversity%20analysis%20with%20bacterial%20species%20visualization%2C%20phylogenetic%20trees%2C%20microbial%20community%20structure%20charts%2C%20modern%20microbiology%20research%20with%20clean%20scientific%20background&width=600&height=400&seq=microbiome&orientation=landscape',
      features: [
        '扩增子序列比对与去噪',
        '特征表构建与进化树构建',
        'α多样性与β多样性分析',
        '物种注释与组成分析',
        '群落结构可视化',
        '差异丰度分析',
        '微生物功能预测'
      ]
    },
    {
      id: 'sequencing',
      icon: 'ri-test-tube-line',
      title: '测序服务',
      subtitle: 'Sequencing Services',
      description: '提供全方位的高通量测序服务，包括全基因组测序、转录组测序、表观组测序等，采用先进的测序平台，确保数据质量和准确性。',
      image: 'https://readdy.ai/api/search-image?query=High-throughput%20DNA%20sequencing%20machines%20in%20modern%20laboratory%2C%20automated%20sequencing%20workflow%2C%20genomic%20data%20generation%20process%2C%20professional%20sequencing%20facility%20with%20clean%20scientific%20background&width=600&height=400&seq=sequencing&orientation=landscape',
      features: [
        '全基因组测序（WGS）',
        '全外显子测序（WES）',
        'RNA-seq转录组测序',
        '单细胞RNA测序（scRNA-seq）',
        'ATAC-seq表观组测序',
        'ChIP-seq蛋白质-DNA相互作用测序',
        '16S/18S/ITS扩增子测序',
        '宏基因组测序'
      ]
    },
    {
      id: 'wet-lab',
      icon: 'ri-test-tube-fill',
      title: '湿实验服务',
      subtitle: 'Wet Laboratory Services',
      description: '提供专业的分子生物学实验服务，包括细胞培养、蛋白表达、基因功能验证等，为生物信息学分析结果提供实验验证支持。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20molecular%20biology%20laboratory%20with%20scientists%20conducting%20experiments%2C%20cell%20culture%20facilities%2C%20PCR%20machines%2C%20protein%20analysis%20equipment%2C%20professional%20wet%20lab%20environment%20with%20clean%20scientific%20background&width=600&height=400&seq=wet-lab&orientation=landscape',
      features: [
        '细胞培养与细胞系构建',
        'PCR扩增与基因克隆',
        '蛋白表达与纯化',
        'Western Blot蛋白检测',
        '免疫荧光染色',
        '流式细胞术分析',
        '基因功能验证实验',
        '细胞功能检测实验'
      ]
    },
    {
      id: 'multiomics',
      icon: 'ri-git-merge-line',
      title: '多组学整合分析',
      subtitle: 'Multi-omics Integration',
      description: '通过整合基因组、转录组、蛋白质组、代谢组等多维度生物学数据，构建系统级生物网络模型，深度解析复杂生物过程的分子调控机制。',
      image: 'https://readdy.ai/api/search-image?query=Multi-omics%20data%20integration%20visualization%20with%20interconnected%20networks%2C%20genomics%20transcriptomics%20proteomics%20metabolomics%20data%20layers%2C%20systems%20biology%20analysis%20with%20clean%20scientific%20background&width=600&height=400&seq=multiomics&orientation=landscape',
      features: [
        '多层次组学数据标准化与质控',
        '跨组学关联分析与因果推断',
        '多维度调控网络重构',
        '生物标志物发现',
        '时空动态调控模式解析',
        '个体化分子分型与预测建模',
        '功能模块识别与通路富集',
        '表型驱动的分子机制解析'
      ]
    },
    {
      id: 'ai-analysis',
      icon: 'ri-brain-line',
      title: '机器/深度学习',
      subtitle: 'Machine Learning & Deep Learning',
      description: '基于机器学习和深度学习算法进行多模态建模与AI分析预测',
      image: 'https://readdy.ai/api/search-image?query=Machine%20learning%20neural%20network%20models%20analyzing%20biological%20data%2C%20deep%20learning%20algorithms%20processing%20genomic%20sequences%2C%20computational%20biology%20modeling%20with%20data%20visualization%20charts%2C%20modern%20bioinformatics%20analysis%20interface&width=600&height=400&seq=ml-analysis&orientation=landscape',
      features: [
        '经典机器学习模型（SVM、XGBoost、Random Forest）',
        '深度学习框架（CNN、Transformer、VAE、GNN）',
        '多模态预训练与任务微调',
        '跨模态融合与算法创新开发',
        '疾病预测与分型分析',
        '模型解释与性能评估',
        '生成式大模型应用',
        '科研级AI模型构建'
      ]
    },
    {
      id: 'research-guidance',
      icon: 'ri-lightbulb-line',
      title: '研究思路指导',
      subtitle: 'Research Strategy Consulting',
      description: '提供专业的研究方向匹配、数据检索筛选、可行性评估等全方位学术指导服务，结合公共数据库资源，为科研项目提供创新性建议和分析逻辑。',
      image: 'https://readdy.ai/api/search-image?query=Scientific%20research%20strategy%20planning%20with%20academic%20experts%20discussing%20research%20methodology%2C%20innovative%20thinking%20process%2C%20modern%20university%20laboratory%20setting%20with%20clean%20professional%20background&width=600&height=400&seq=research-guidance&orientation=landscape',
      features: [
        '研究方向匹配与领域趋势分析',
        '公共数据库检索与数据筛选',
        '可行性评估与技术兼容性分析',
        '数据来源清单与筛选理由',
        '后续分析路径规划',
        '创新性建议与研究亮点挖掘',
        '分析逻辑与文章结构建议',
        '实验验证方案设计'
      ]
    },
    {
      id: 'paper-polishing',
      icon: 'ri-edit-line',
      title: '论文润色与发表支持',
      subtitle: 'Academic Paper Polishing & Publishing Support',
      description: '提供专业的英文学术论文润色、图表设计和投稿指导服务，确保语言表达的准确性、规范性与学术性，助力高水平期刊发表。',
      image: 'https://readdy.ai/api/search-image?query=Academic%20paper%20editing%20and%20polishing%20service%20with%20professional%20editors%20reviewing%20scientific%20manuscripts%2C%20graphical%20abstract%20design%2C%20modern%20publishing%20office%20with%20clean%20academic%20background&width=600&height=400&seq=paper-polishing&orientation=landscape',
      features: [
        '专业学术英文改写与润色',
        '符合SCI期刊表达规范',
        '主图与Graphical Abstract设计',
        '图表配色与排版优化',
        '期刊匹配与投稿策略',
        'Cover letter撰写指导',
        '审稿意见回复支持'
      ]
    }
  ];

  const servicePackages = [
    {
      name: '标准版',
      level: 'standard',
      description: '标准化pipeline执行',
      suitable: 'IF ≤ 3（探索性课题、硕博论文、一般SCI）',
      positioning: '仅执行标准流程（pipelineIF<=3），包括质控、比对、差异分析、功能富集。不含任何定制分析、逻辑调整或生物学解读。客户需自行解读结果。',
      features: [
        '标准流程执行（pipelineIF<=3）',
        '数据质控与序列比对',
        '差异分析与功能富集',
        '分析结果图表原文件/矢量图交付',
        '原始数据提供'
      ],
      limitations: [
        '❌ 不含定制分析（固定流程）',
        '❌ 不提供生物学解读',
        '❌ 不支持结果修改',
        '❌ 不提供研究思路设计',
        '❌ 不提供代码',
        '❌ 不保证实验验证支持'
      ],
      specifications: {
        customization: '❌ 固定流程',
        interpretation: '❌ 不提供',
        modification: '❌ 否',
        research_design: '❌ 否',
        figure_standard: '标准样式',
        experiment_support: '❌ 不保证',
        raw_data: '✅ 提供',
        code: '❌ 不提供'
      },
      color: 'bg-blue-500'
    },
    {
      name: '进阶版',
      level: 'advanced',
      description: '定制化分析与结果解读',
      suitable: 'IF 5–8（机制研究、基金项目）',
      positioning: '客户提出明确问题（如提出兴趣基因、通路、细胞群或信号轴），可指定分析方向（如细胞分化轨迹、基因调控网络、细胞互作预测、功能模块识别等）。',
      features: [
        '客户指定分析方向',
        '定制化分析执行',
        '二次汇报与结果解读',
        '服务期限内修改（交付后3个月内）',
        '分析结果图表原文件/矢量图交付',
        '项目结题报告',
        '原始数据提供',
        '可提供绘图代码',
        '部分湿实验验证支持'
      ],
      limitations: [
        '需客户提出明确研究问题',
        '不含研究思路设计'
      ],
      specifications: {
        customization: '✅ 客户明确问题',
        interpretation: '✅ 二次汇报',
        modification: '✅ 服务期限内（交付后3个月内）',
        research_design: '❌ 否',
        figure_standard: 'IF5-8标准样式',
        experiment_support: '⚠️ 部分保证。可提供简单实验设计建议与关键marker筛选（如免疫染色、qPCR、Western blot）',
        raw_data: '✅ 提供',
        code: '⚠️ 可提供部分绘图代码'
      },
      color: 'bg-green-500'
    },
    {
      name: '旗舰版',
      level: 'flagship',
      description: '研究思路设计与深度合作',
      suitable: 'IF ≥ 10（高水平研究）',
      positioning: '除执行分析外，提供研究思路设计与分析框架搭建，包括假设构建、逻辑规划、方法学路径选择、关键结果组织等。',
      features: [
        '研究思路设计与分析框架搭建',
        '假设构建与逻辑规划',
        '方法学路径选择',
        '多轮汇报与逻辑整理',
        '服务期限内修改（交付后一年内）',
        '高阶湿实验验证支持',
        '可要求任意子刊级别出图效果',
        '分析结果图表原文件/矢量图交付',
        '项目结题报告',
        '文章思路输出',
        '原始数据提供',
        '可提供绘图代码'
      ],
      limitations: [],
      specifications: {
        customization: '✅ 我方设计思路',
        interpretation: '✅ 多轮汇报与逻辑整理',
        modification: '✅ 服务期限内（交付后一年内）',
        research_design: '✅ 含研究设计与逻辑架构',
        figure_standard: '可要求任意子刊级别出图效果',
        experiment_support: '✅ 支持湿实验逻辑设计、marker筛选与验证路径规划（如体外功能实验、动物模型验证等），确保分析结论具备可验证性',
        raw_data: '✅ 提供',
        code: '✅ 提供绘图代码'
      },
      color: 'bg-purple-500',
      highlight: true
    }
  ];

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            定制化<strong>科研服务</strong>解决方案
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            我们提供从<strong>组学数据分析</strong>到<strong>成果发表</strong>的完整科研服务链条，并以<strong>严格的数据保密机制</strong>保障全流程安全可靠。
          </p>
        </div>

        {/* 服务档次说明 */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-8">选择适合您的服务标准</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {servicePackages.map((pkg, index) => (
              <div
                key={index}
                className={`relative bg-white rounded-xl overflow-hidden transition-all duration-300 hover:scale-105 ${pkg.level === 'standard'
                    ? 'shadow-md border border-gray-200'
                    : pkg.level === 'advanced'
                      ? 'shadow-lg border-2 border-green-300'
                      : 'shadow-2xl border-2 border-purple-400'
                  }`}
              >
                {/* 顶部装饰条 */}
                <div className={`h-2 ${pkg.level === 'standard'
                    ? 'bg-gradient-to-r from-blue-400 to-blue-600'
                    : pkg.level === 'advanced'
                      ? 'bg-gradient-to-r from-green-400 to-green-600'
                      : 'bg-gradient-to-r from-purple-500 via-pink-500 to-purple-600'
                  }`}></div>

                <div className="p-6">
                  {/* 图标和标题 */}
                  <div className={`w-16 h-16 flex items-center justify-center rounded-xl mx-auto mb-4 ${pkg.level === 'standard'
                      ? 'bg-blue-100'
                      : pkg.level === 'advanced'
                        ? 'bg-green-100'
                        : 'bg-gradient-to-br from-purple-500 to-pink-500 shadow-lg'
                    }`}>
                    <i className={`${pkg.level === 'standard'
                        ? 'ri-star-line text-blue-600 text-2xl'
                        : pkg.level === 'advanced'
                          ? 'ri-settings-3-line text-green-600 text-2xl'
                          : 'ri-vip-crown-line text-white text-3xl'
                      }`}></i>
                  </div>

                  <h4 className={`text-2xl font-bold text-center mb-2 ${pkg.level === 'flagship' ? 'bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent' : 'text-gray-900'
                    }`}>
                    {pkg.name}
                  </h4>

                  <p className="text-center text-gray-600 mb-4 text-sm">{pkg.description}</p>

                  <div className={`rounded-lg p-3 mb-4 ${pkg.level === 'standard'
                      ? 'bg-blue-50'
                      : pkg.level === 'advanced'
                        ? 'bg-green-50'
                        : 'bg-gradient-to-r from-purple-50 to-pink-50'
                    }`}>
                    <p className="text-sm text-gray-700 text-center">
                      <strong>适用于：</strong>{pkg.suitable}
                    </p>
                  </div>

                  {/* 服务定位 */}
                  <div className={`rounded-lg p-3 mb-4 ${pkg.level === 'standard'
                      ? 'bg-gray-50'
                      : pkg.level === 'advanced'
                        ? 'bg-green-50'
                        : 'bg-gradient-to-br from-purple-50 via-pink-50 to-purple-50'
                    }`}>
                    <h5 className="text-sm font-semibold text-gray-800 mb-2">服务定位：</h5>
                    <p className="text-xs text-gray-600 leading-relaxed">{pkg.positioning}</p>
                  </div>

                  {/* 服务边界与交付规范 */}
                  <div className={`rounded-lg p-3 mb-4 ${pkg.level === 'standard'
                      ? 'bg-yellow-50'
                      : pkg.level === 'advanced'
                        ? 'bg-yellow-50'
                        : 'bg-gradient-to-br from-amber-50 to-yellow-50'
                    }`}>
                    <h5 className="text-sm font-semibold text-gray-800 mb-3">服务边界与交付规范：</h5>
                    <div className="space-y-2">
                      <div className="flex justify-between items-start text-xs">
                        <span className="text-gray-600 font-medium">是否定制：</span>
                        <span className="text-gray-700 text-right flex-1 ml-2">{pkg.specifications.customization}</span>
                      </div>
                      <div className="flex justify-between items-start text-xs">
                        <span className="text-gray-600 font-medium">是否解读：</span>
                        <span className="text-gray-700 text-right flex-1 ml-2">{pkg.specifications.interpretation}</span>
                      </div>
                      <div className="flex justify-between items-start text-xs">
                        <span className="text-gray-600 font-medium">是否修改：</span>
                        <span className="text-gray-700 text-right flex-1 ml-2">{pkg.specifications.modification}</span>
                      </div>
                      <div className="flex justify-between items-start text-xs">
                        <span className="text-gray-600 font-medium">是否出思路：</span>
                        <span className="text-gray-700 text-right flex-1 ml-2">{pkg.specifications.research_design}</span>
                      </div>
                      <div className="flex justify-between items-start text-xs">
                        <span className="text-gray-600 font-medium">出图标准：</span>
                        <span className="text-gray-700 text-right flex-1 ml-2">{pkg.specifications.figure_standard}</span>
                      </div>
                      <div className="flex justify-between items-start text-xs">
                        <span className="text-gray-600 font-medium">原始数据：</span>
                        <span className="text-gray-700 text-right flex-1 ml-2">{pkg.specifications.raw_data}</span>
                      </div>
                      <div className="flex justify-between items-start text-xs">
                        <span className="text-gray-600 font-medium">代码：</span>
                        <span className="text-gray-700 text-right flex-1 ml-2">{pkg.specifications.code}</span>
                      </div>
                    </div>
                  </div>

                  {/* 湿实验验证支持 */}
                  <div className={`rounded-lg p-3 ${pkg.level === 'standard'
                      ? 'bg-green-50'
                      : pkg.level === 'advanced'
                        ? 'bg-green-50'
                        : 'bg-gradient-to-br from-emerald-50 to-green-50'
                    }`}>
                    <h5 className="text-sm font-semibold text-gray-800 mb-2">湿实验验证支持：</h5>
                    <p className="text-xs text-gray-600 leading-relaxed">{pkg.specifications.experiment_support}</p>
                  </div>
                </div>

                {/* 旗舰版底部光效 */}
                {pkg.level === 'flagship' && (
                  <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-purple-400 to-transparent opacity-50"></div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* 服务列表 */}
          <div className="lg:col-span-1">
            <div className="space-y-4">
              {services.map((service, index) => (
                <div
                  key={service.id}
                  className={`p-4 rounded-lg cursor-pointer transition-all duration-300 ${activeService === index
                      ? 'bg-blue-600 text-white shadow-lg'
                      : 'bg-gray-50 hover:bg-gray-100 text-gray-900'
                    }`}
                  onClick={() => setActiveService(index)}
                >
                  <div className="flex items-center space-x-3">
                    <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${activeService === index ? 'bg-white/20' : 'bg-blue-100'
                      }`}>
                      <i className={`${service.icon} text-lg ${activeService === index ? 'text-white' : 'text-blue-600'
                        }`}></i>
                    </div>
                    <div>
                      <h3 className="font-semibold">{service.title}</h3>
                      <p className={`text-sm ${activeService === index ? 'text-blue-100' : 'text-gray-500'
                        }`}>
                        {service.subtitle}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 服务详情 */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="relative h-64">
                <img
                  src={services[activeService].image}
                  alt={services[activeService].title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-6 text-white">
                  <h3 className="text-2xl font-bold mb-2">{services[activeService].title}</h3>
                  <p className="text-blue-200">{services[activeService].subtitle}</p>
                </div>
              </div>

              <div className="p-8">
                <p className="text-gray-600 mb-8 leading-relaxed">
                  {services[activeService].description}
                </p>

                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                    <i className="ri-settings-line text-blue-600 mr-2"></i>
                    核心功能
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {services[activeService].features.map((feature, index) => (
                      <div key={index} className="text-sm text-gray-600 flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        {feature}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mt-8 pt-6 border-t border-gray-200">
                  <div className="flex justify-center">
                    <button
                      onClick={handleContactClick}
                      className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-phone-line mr-2"></i>
                      立即咨询
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesList;
